var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M310.627 438.627l160-160c12.497-12.496 12.497-32.758 0-45.255l-160-160c-12.497-12.496-32.758-12.496-45.255 0-12.497 12.497-12.497 32.758 0 45.255L370.745 224H64c-17.673 0-32 14.327-32 32s14.327 32 32 32h306.745L265.372 393.373C259.124 399.621 256 407.811 256 416s3.124 16.379 9.372 22.627c12.497 12.497 32.758 12.497 45.255 0z"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
